var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.latLngD)?_c('l-marker',{attrs:{"lat-lng":_vm.latLngD,"icon":_vm.icon,"radius":_vm.markerRadius,"color":_vm.markerColour,"opacity":_vm.markerOpacity}},[_c('l-popup',[_c('DeathPopupContent',{attrs:{"death":_vm.death}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }